import React, { Component, Fragment } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, bindActionCreators as bind } from 'redux';

import GetInTouchFlow from '../components/GetInTouchFlow/Flow';
import { mp, getCampaign } from '../constants/utils';

import { Diagnostic } from '../data/ducks';
import Result from '../components/GetInTouchFlow/Result';
import Text from '../components/shared/Text';
import QuestionReference from '../components/GoalsFlow/QuestionReference';
import { PENSION_PLAN_PRICE } from '../constants/constants';

export const questionTypes = {
  NUMERIC: 'number',
  YESNO: 'yes-no',
  SELECTION: 'select',
};

const GetInTouchSteps = [GetInTouchFlow, Result];

const callPeriodQuestion = {
  inputName: 'call_period',
  base: true,
  value: null,
  type: questionTypes.YESNO,
  startText: 'Quiero que platiquemos',
  answers: [
    {
      label: 'Cuanto antes',
      value: '0',
    },
    {
      label: 'Mañana',
      value: '1',
    },
  ],
  when: '',
  reference: (
    <QuestionReference>
      <Text type="reference">
        Al seleccionar una de estas opciones estás aceptando los{' '}
        <a target="_blank" href="https://www.finauta.com/terminos">
          términos y condiciones
        </a>{' '}
        y el{' '}
        <a target="_blank" href="https://www.finauta.com/aviso">
          aviso de privacidad
        </a>{' '}
        de Finauta.
      </Text>
    </QuestionReference>
  ),
};

class GetInTouchContainer extends Component {
  state = {
    currentStep: 0,
  };

  componentWillMount = () => {
    const questions = [
      {
        label: '',
        value: '',
        questions: [
          {
            inputName: 'name',
            value: null,
            type: questionTypes.NUMERIC,
            // pattern: '[0-9]*',
            isTextual: true,
            prepend: '',
            startText: 'Me llamo: ',
            endText: '',
            placeholder: '',
            isCurrency: false,
            maxDigits: 40,
            inputWidth: 8,
            validation: Yup.string().required('Este es un campo requerido'),
          },
        ],
      },
    ];

    console.log(this.props.match.params);

    if (!this.props.match.params.email) {
      questions[0].questions.push({
        inputName: 'emailForm',
        base: true,
        prepend: '',
        endText: '',
        startText: 'Mi correo es: ',
        type: questionTypes.NUMERIC,
        isTextual: true,
        isCurrency: false,
        placeholder: 'tucorreo@ejemplo.com',
        maxDigits: 80,
        inputSpanWidth: 20,
        inputWidth: '250px',
        inputMaxWidth: 100,
        validation: Yup.string()
          .email('Debe ser un correo electrónico válido')
          .required('Este es un campo requerido'),
        reference: null,
      });
      questions[0].questions.push({
        inputName: 'phone',
        value: '',
        type: questionTypes.NUMERIC,
        pattern: '[0-9]*',
        prepend: '+52 1 ',
        startText: 'Mi celular es: ',
        endText: '',
        placeholder: '',
        maxDigits: 10,
        inputWidth: 8,
        noThousandSeparator: true,
        validation: Yup.string()
          .matches(/^\d{10}$/, 'Debe contener exactamente 10 dígitos')
          .required('Este es un campo requerido'),
        disclaimer: (
          <QuestionReference>
            <Text type="reference" styles={{ marginTop: '10px' }}>
              Al dar click en "Solicitar plan" estás aceptando los{' '}
              <a target="_blank" href="https://www.finauta.com/terminos">
                términos y condiciones
              </a>{' '}
              y el{' '}
              <a target="_blank" href="https://www.finauta.com/aviso">
                aviso de privacidad
              </a>{' '}
              de Finauta.
            </Text>
          </QuestionReference>
        ),
        final: 'Solicitar plan',
      });
    } else {
      questions[0].questions.push({
        inputName: 'phone',
        value: '',
        type: questionTypes.NUMERIC,
        pattern: '[0-9]*',
        prepend: '+52 1 ',
        startText: 'Mi celular es ',
        final: '→ Ir a agendar llamada',
        endText: '',
        placeholder: '',
        maxDigits: 10,
        inputWidth: 8,
        noThousandSeparator: true,
        validation: Yup.string()
          .matches(/^\d{10}$/, 'Debe contener exactamente 10 dígitos')
          .required('Este es un campo requerido'),
        reference: (
          <QuestionReference>
            <Text type="reference">
              Lo utilizaremos para marcarte en la fecha y hora que tú elijas
            </Text>
          </QuestionReference>
        ),
      });
    }
    this.setState({ questionnaire: questions, totalSteps: GetInTouchSteps.length });
  };

  componentDidMount = () => {
    mp(`[${getCampaign(window.location.href)}] | Contacto | Entra`);
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < totalSteps - 1) {
      this.setState((state) => ({ currentStep: state.currentStep + 1 }));
    }
  };

  handleStepSubmit = (data) => {
    // eslint-disable-next-line react/prop-types, react/destructuring-assignment
    const { tool, planLink, source } = this.props.match.params;

    const options = data[0];

    let period;

    period = data[0].call_period === '1' ? 'mañana o el siguiente día hábil.' : 'muy pronto.';

    if (data[0].call_period === 0) {
      period = 'cuanto antes';
    } else if (data[0].call_period === 1) {
      period = 'mañana';
    }

    mp(`[${getCampaign(window.location.href)}] | Contacto | Agendo para ${period}`);
    this.setState({ when: period });
    options.planLink = decodeURIComponent(planLink);
    options.source = source || '';
    options.tool = tool;
    options.price = PENSION_PLAN_PRICE;
    this.props.sendAvailabilityData(options);
    this.nextStep();
  };

  render() {
    const CurrentStep = GetInTouchSteps[this.state.currentStep];
    return (
      <Fragment>
        <CurrentStep
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={this.state.questionnaire}
          result={this.props.result}
          when={this.state.when}
          tool={this.props.match.params.tool}
        />
      </Fragment>
    );
  }
}

GetInTouchContainer.propTypes = {
  result: PropTypes.object,
};

GetInTouchContainer.defaultProps = {
  result: {},
};

const mapStateToProps = (state) => ({
  result: state.diagnostic.result,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      sendAvailabilityData: Diagnostic.Creators.sendAvailabilityDataRequested,
    },
    dispatch,
  );

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(GetInTouchContainer);
